import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Category from "../FetchApi/Category";
import Products from "../FetchApi/Products";
import { IMG_BASE_URL, FREE_DELIVERY_ENABLED } from "../config";
import ManageCart from '../Controllers/ManageCart';
import ManageWishlist from '../Controllers/ManageWishlist';
import ColorSwatch from '../components/ColorSwatch';

// CSS class for visually hidden elements (accessible to screen readers but not visible)
const visuallyHiddenStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: '0'
};

export default function Header() {
  const { handleOnChangeValue, addToCart, cartItems, handleDeleteItem } = ManageCart();
  const { wishlistItems } = ManageWishlist();
  const totalBilling = cartItems.reduce((acc, item) => acc + (item.SalePrice * item.quantity), 0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedImages, setSelectedImages] = useState({}); // Track selected image for each product
  const [loadingImages, setLoadingImages] = useState({}); // Track loading state for each product
  const navigate = useNavigate();

  const styles = {
    productDetailsVariation: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '20px',
      alignItems: 'start',
    },
    productDetailsVariationItem: {
      padding: '0',
      borderRadius: '0',
    },
    productDetailsVariationTitle: {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '12px',
    },
    productDetailsVariationList: {
      marginTop: '10px',
      display: 'flex',
      gap: '5px',
      flexWrap: 'wrap',
    },
    colorVariationBtn: {
      width: '20px',  // Square size
      height: '20px',
      cursor: 'pointer',
      position: 'relative',
      borderRadius: '2px',
      transition: 'transform 0.3s',
      backgroundColor: '#ddd',
    },
    colorVariationBtnHover: {
      transform: 'scale(1.05)',
    },
    colorVariationTooltip: {
      visibility: 'hidden',
      backgroundColor: '#222',
      color: '#fff',
      textAlign: 'center',
      borderRadius: '6px',
      padding: '8px',
      position: 'absolute',
      zIndex: 10,
      bottom: '140%',
      left: '50%',
      transform: 'translateX(-50%)',
      opacity: 0,
      transition: 'opacity 0.3s, visibility 0.3s',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
    colorVariationTooltipVisible: {
      visibility: 'visible',
      opacity: 1,
    },
    imageContainer: {
      position: "relative",
      overflow: "hidden",
    },
    imageLoading: {
      opacity: 0.6,
      transition: "opacity 0.3s ease",
    },
    loadingOverlay: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    spinner: {
      width: "20px",
      height: "20px",
      border: "1px solid #f3f3f3",
      borderTop: "1px solid #000",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
  };

  const { loadCategory, categories } = Category();
  const { loadProducts, products } = Products();
  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US', {
      // minimumFractionDigits: 2,
      // maximumFractionDigits: 2,
    }).format(number);
  };

  const handleColorSelection = (productId, colorIndex, attributeImages) => {
    const images = attributeImages.split(', ');
    if (images[colorIndex]) {
      // Set loading state
      setLoadingImages(prev => ({
        ...prev,
        [productId]: true
      }));

      // Simulate image loading with a slight delay for better UX
      setTimeout(() => {
        setSelectedImages(prev => ({
          ...prev,
          [productId]: images[colorIndex]
        }));

        // Remove loading state
        setLoadingImages(prev => ({
          ...prev,
          [productId]: false
        }));
      }, 300); // 300ms delay for loading effect
    }
  };

  const getCurrentImage = (product) => {
    // Return selected image if available, otherwise return default thumbnail
    return selectedImages[product.Id] || product.Thumbnai;
  };

  const isImageLoading = (productId) => {
    return loadingImages[productId] || false;
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/shop?search=${encodeURIComponent(searchTerm)}`);
    }
  };
  useEffect(() => {
    loadCategory();
    loadProducts();
  }, []);
  const hasCategories = Array.isArray(categories.categories);
  return (
    <>
      {/* back to top start */}
      <div className="back-to-top-wrapper">
        <button id="back_to_top" type="button" className="back-to-top-btn" aria-label="Back to top">
          <svg width={12} height={7} viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 6L6 1L1 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      {/* back to top end */}
      {/* offcanvas area start */}
      <div className="offcanvas__area offcanvas__radius">
        <div className="offcanvas__wrapper">
          <div className="offcanvas__close">
            <button className="offcanvas__close-btn offcanvas-close-btn" aria-label="Close menu">
              <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 1L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1 1L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
          <div className="offcanvas__content">
            <div className="offcanvas__top mb-70 d-flex justify-content-between align-items-center">
              <div className="offcanvas__logo logo">
                <Link to="/">
                  <img src="/assets/img/logo/logo122.png" alt="logo" style={{ width: '150px' }} />
                </Link>
              </div>
            </div>
            <div className="offcanvas__category pb-40">
              <div className="tp-category-mobile-menu">
              </div>
            </div>
            <div className="tp-main-menu-mobile fix d-lg-none mb-40" />
            <div className="offcanvas__contact align-items-center d-none">
              <div className="offcanvas__contact-icon mr-20">
                <span>
                  <img src="/assets/img/icon/contact.png" alt="contact" />
                </span>
              </div>
              <div className="offcanvas__contact-content">
                <h3 className="offcanvas__contact-title">
                </h3>
              </div>
            </div>
            <div className="offcanvas__btn">
              <Link to="/contactus" className="tp-btn-2 tp-btn-border-2">Contact Us</Link>
            </div>
          </div>
          <div className="offcanvas__bottom">
            <div className="offcanvas__footer d-flex align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </div>
      <div className="body-overlay" />
      {/* offcanvas area end */}
      {/* mobile menu area start */}
      <div id="tp-bottom-menu-sticky" className="tp-mobile-menu d-lg-none">
        <div className="container">
          <div className="row row-cols-4">
            <div className="col-3">
              <div className="tp-mobile-item text-center">
                <Link to="/shop" className="tp-mobile-item-btn">
                  <i className="flaticon-store" />
                  <span>Store</span>
                </Link>
              </div>
            </div>
            <div className="col-3">
              <div className="tp-mobile-item text-center">
                <button className="tp-mobile-item-btn tp-search-open-btn" aria-label="Open search">
                  <i className="flaticon-search-1" />
                  <span>Search</span>
                </button>
              </div>
            </div>
            <div className="col-3">
              <div className="tp-mobile-item text-center">
                <Link to="/wishlist" className="tp-mobile-item-btn" aria-label="View Wishlist">
                  <i className="flaticon-love" />
                  <span>Wishlist {wishlistItems.length > 0 && `(${wishlistItems.length})`}</span>
                </Link>
              </div>
            </div>
            <div className="col-3">
              <div className="tp-mobile-item text-center">
                <button className="tp-mobile-item-btn tp-offcanvas-open-btn" aria-label="Open menu">
                  <i className="flaticon-menu-1" />
                  <span>Menu</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* mobile menu area end */}
      {/* search area start */}
      <section className="tp-search-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-search-form">
                <div className="tp-search-close text-center mb-20">
                  <button className="tp-search-close-btn tp-search-close-btn" aria-label="Close search" />
                </div>
                <form onSubmit={handleSearchSubmit}>
                  <div className="tp-search-input mb-10">
                    <input type="text" placeholder="Search for product..." value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} />
                    <button type="submit" aria-label="Search"><i className="flaticon-search-1" /></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* search area end */}
      {/* cart mini area start */}
      <div className="cartmini__area tp-all-font-roboto">
        <div className="cartmini__wrapper d-flex justify-content-between flex-column">
          <div className="cartmini__top-wrapper">
            <div className="cartmini__top p-relative">
              <div className="cartmini__top-title">
                <h4>Shopping cart</h4>
              </div>
              <div className="cartmini__close">
                <button type="button" className="cartmini__close-btn cartmini-close-btn" aria-label="Close cart"><i className="fal fa-times" /></button>
              </div>
            </div>
            <div className="cartmini__widget">
              {cartItems.length > 0 ? (
                cartItems.map((item, index) => (
                  <div key={index} className="cartmini__widget-item">
                    <div className="cartmini__thumb">
                      <Link to={`/product/${item.Id}/${item.Slug}`}> <img src={`${IMG_BASE_URL}${item.attimage}`} alt="product" /></Link>
                    </div>

                    <div className="cartmini__content">
                      <h5 className="cartmini__title"><Link to={`/product/${item.Id}/${item.Slug}`}>{item.Name}<br />({item.ArticleNo})</Link> <span className="cartmini__quantity"> x {item.quantity}</span></h5>
                      <div className="cartmini__price-wrapper">
                        {item.IsSale === 1 ? (
                          <>
                            <span style={{ textDecoration: 'line-through', color: '#888', fontSize: '14px', marginRight: 8 }}>
                              PKR {formatNumber(parseFloat(item.OrignalPrice) * item.quantity)}
                            </span>
                            <span style={{ color: '#e53935', fontWeight: 700, fontSize: '16px' }}>
                              PKR {formatNumber(parseFloat(item.SalePrice) * item.quantity)}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="cartmini__price">PKR {formatNumber(parseFloat(item.SalePrice) * item.quantity)}</span>
                          </>
                        )}
                      </div>
                    </div>

                    <button onClick={() => handleDeleteItem(index)} className="cartmini__del" aria-label={`Remove ${item.Name} from cart`}><i className="fa-regular fa-xmark" /></button>
                  </div>
                ))
              ) : (
                <>
                  <img src="/assets/img/product/cartmini/empty-cart.png" style={{ marginTop: '20px' }} alt="cart" />
                  <p>Your Cart is empty</p>
                  <Link to="/shop" className="tp-btn mb-10 w-100" style={{ textAlign: 'center' }}>Go to Shop</Link>
                </>
              )}
            </div>
          </div>
          <div className="cartmini__checkout">
            <div className="cartmini__checkout-title mb-30">
              <h4>Subtotal:</h4>
              <span>PKR {formatNumber(totalBilling)}</span>
            </div>
            <div className="cartmini__checkout-btn">
              <Link to="/cartItems" className="tp-btn mb-10 w-100">view cart</Link>
            </div>
          </div>
        </div>
      </div>
      {/* cart mini area end */}
      {/* header area start */}
      <header>
        <div className="tp-header-area p-relative z-index-11">
          {/* header top start  */}
          <div className="tp-header-top black-bg p-relative z-index-1 d-none d-md-block">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="tp-header-welcome d-flex align-items-center">
                    <span>
                      <svg width={22} height={19} viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.6364 1H1V12.8182H14.6364V1Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.6364 5.54545H18.2727L21 8.27273V12.8182H14.6364V5.54545Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.0909 17.3636C6.3461 17.3636 7.36363 16.3461 7.36363 15.0909C7.36363 13.8357 6.3461 12.8182 5.0909 12.8182C3.83571 12.8182 2.81818 13.8357 2.81818 15.0909C2.81818 16.3461 3.83571 17.3636 5.0909 17.3636Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16.9091 17.3636C18.1643 17.3636 19.1818 16.3461 19.1818 15.0909C19.1818 13.8357 18.1643 12.8182 16.9091 12.8182C15.6539 12.8182 14.6364 13.8357 14.6364 15.0909C14.6364 16.3461 15.6539 17.3636 16.9091 17.3636Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    {FREE_DELIVERY_ENABLED && (
                      <p>Free Delivery when you spend <span>PKR 15,000</span></p>
                    )}
                    {/* <p>Flat <span>14% Off</span>On Entire Stock.</p> */}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="tp-header-top-right d-flex align-items-center justify-content-end">
                    <div className="tp-header-top-menu d-flex align-items-center justify-content-end">
                      <div style={{ color: 'white', cursor: 'pointer', marginBottom: '3px', marginTop: '3px' }}>
                        <span> <Link to="/contactus">Contact Us</Link></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* header main start */}
          <div className="tp-header-main tp-header-sticky">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-2 col-md-4 col-6">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/img/logo/logo122.png" alt="logo" style={{ width: '150px' }} />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-7 d-none d-lg-block">
                  <div className="tp-header-search pl-70">
                    <form onSubmit={handleSearchSubmit}>
                      <div className="tp-header-search-wrapper d-flex align-items-center">
                        <div className="tp-header-search-box">
                          <input type="text" placeholder="Search for Products..." value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                        <div className="tp-header-search-btn">
                          <button type="submit" aria-label="Search">
                            <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-3 col-md-8 col-6">
                  <div className="tp-header-main-right d-flex align-items-center justify-content-end">
                    <div className="tp-header-action d-flex align-items-center ml-50">
                      <div className="tp-header-action-item d-none d-lg-block">
                        <Link to="/wishlist" className="tp-header-action-btn" aria-label="View Wishlist">
                          <svg width={22} height={20} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M11.239 18.8538C13.4096 17.5179 15.4289 15.9456 17.2607 14.1652C18.5486 12.8829 19.529 11.3198 20.1269 9.59539C21.2029 6.25031 19.9461 2.42083 16.4289 1.28752C14.5804 0.692435 12.5616 1.03255 11.0039 2.20148C9.44567 1.03398 7.42754 0.693978 5.57894 1.28752C2.06175 2.42083 0.795919 6.25031 1.87187 9.59539C2.46978 11.3198 3.45021 12.8829 4.73806 14.1652C6.56988 15.9456 8.58917 17.5179 10.7598 18.8538L10.9949 19L11.239 18.8538Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M7.26062 5.05302C6.19531 5.39332 5.43839 6.34973 5.3438 7.47501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span style={visuallyHiddenStyle}>Wishlist</span>
                          {wishlistItems.length > 0 && (
                            <span className="tp-header-action-badge">{wishlistItems.length}</span>
                          )}
                        </Link>
                      </div>
                      <div className="tp-header-action-item">
                        <button type="button" className="tp-header-action-btn cartmini-open-btn" aria-label="Open shopping cart">
                          <svg width={21} height={22} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6.48626 20.5H14.8341C17.9004 20.5 20.2528 19.3924 19.5847 14.9348L18.8066 8.89359C18.3947 6.66934 16.976 5.81808 15.7311 5.81808H5.55262C4.28946 5.81808 2.95308 6.73341 2.4771 8.89359L1.69907 14.9348C1.13157 18.889 3.4199 20.5 6.48626 20.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6.34902 5.5984C6.34902 3.21232 8.28331 1.27803 10.6694 1.27803V1.27803C11.8184 1.27316 12.922 1.72619 13.7362 2.53695C14.5504 3.3477 15.0081 4.44939 15.0081 5.5984V5.5984" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M7.70365 10.1018H7.74942" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M13.5343 10.1018H13.5801" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="tp-header-action-badge">{cartItems.length}</span>
                        </button>
                      </div>
                      <div className="tp-header-action-item d-lg-none">
                        <button type="button" className="tp-header-action-btn tp-offcanvas-open-btn" aria-label="Open menu">
                          <svg xmlns="http://www.w3.org/2000/svg" width={30} height={16} viewBox="0 0 30 16">
                            <rect x={10} width={20} height={2} fill="currentColor" />
                            <rect x={5} y={7} width={25} height={2} fill="currentColor" />
                            <rect x={10} y={14} width={20} height={2} fill="currentColor" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* header bottom start */}
          <div className="tp-header-bottom tp-header-bottom-border d-none d-lg-block">
            <div className="container">
              <div className="tp-mega-menu-wrapper p-relative">
                <div className="row align-items-center">
                  <div className="col-xl-3 col-lg-3">
                    <div className="tp-header-category tp-category-menu tp-header-category-toggle">
                      <button className="tp-category-menu-btn tp-category-menu-toggle" aria-label="Toggle category menu">
                        <span>
                          <svg width={18} height={14} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1ZM0 7C0 6.44772 0.447715 6 1 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H1C0.447715 8 0 7.55228 0 7ZM1 12C0.447715 12 0 12.4477 0 13C0 13.5523 0.447715 14 1 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12H1Z" fill="currentColor" />
                          </svg>
                        </span>
                        All Categories
                      </button>
                      <nav className="tp-category-menu-content">
                        {hasCategories && (<>
                          {categories.categories.length > 0 && (
                            <>
                              <ul>
                                {categories.categories.map((category) => (
                                  <li key={category.Id} className="has-dropdown has-mega-menu">
                                    <Link to={`/shop?category=${encodeURIComponent(category.Id)}`}>{category.Name}</Link>
                                    <ul className="mega-menu tp-submenu">
                                      <div className="row">
                                        <div className="col-xl-12">
                                          <div className="tp-product-tab-content">
                                            <div className="tab-content" id="myTabContent">
                                              <div className="tab-pane fade show active" id="new-tab-pane" role="tabpanel" aria-labelledby="new-tab" tabIndex={0}>
                                                <div className="row">
                                                  {Array.isArray(products.products) && products.products.length > 0 && (
                                                    products.products
                                                      .filter(
                                                        (product) => product.SubCategoryId === category.Id
                                                      )
                                                      .slice(0, 3)
                                                      .map((product) => (
                                                        <div key={product.Id} className="col-xl-4 col-lg-4 col-sm-6">
                                                          <div className="tp-product-item p-relative transition-3 mb-25">
                                                            <div className="tp-product-thumb p-relative fix m-img" style={styles.imageContainer}>
                                                              <a href={`/product/${product.Id}/${product.Slug}`}>
                                                                <img
                                                                  src={`${IMG_BASE_URL}${getCurrentImage(product)}`}
                                                                  alt="product-electronic"
                                                                  style={isImageLoading(product.Id) ? styles.imageLoading : {}}
                                                                />
                                                              </a>
                                                              {isImageLoading(product.Id) && (
                                                                <div style={styles.loadingOverlay}>
                                                                  <div style={styles.spinner}></div>
                                                                </div>
                                                              )}
                                                              {product.IsSale === 1 ? (
                                                                <div className="tp-product-badge">
                                                                  <span className="product-trending">Sale</span>
                                                                </div>) : (<div className="tp-product-badge">
                                                                  <span className="product-hot">Hot</span>
                                                                </div>)}
                                                              {/* <div className="tp-product-badge">
                                                                <span className="product-hot">Hot</span>
                                                              </div> */}
                                                            </div>
                                                            <div className="tp-product-content">
                                                              <div className="tp-product-category">
                                                                <span className="tp-product-price new-price">
                                                                  <Link
                                                                    to={`/product/${product.Id}/${product.Slug}`}
                                                                  >
                                                                    {product.IsSale === 1 ? (
                                                                      <>
                                                                        <span style={{ textDecoration: 'line-through', color: '#888', fontSize: '16px', marginRight: 8 }}>
                                                                          PKR {formatNumber(product.OrignalPrice)}
                                                                        </span>
                                                                        <span style={{ color: '#e53935', fontWeight: 700, fontSize: '20px' }}>
                                                                          PKR {formatNumber(product.SalePrice)}
                                                                        </span>
                                                                      </>
                                                                    ) : (
                                                                      <>PKR {formatNumber(product.SalePrice)}</>
                                                                    )}
                                                                  </Link>
                                                                  {/* PKR {formatNumber(product.SalePrice)}<br />  */}
                                                                  <a href={`/product/${product.Id}/${product.Slug}`}>{product.Name}<br />({product.ArticleNo})</a>
                                                                </span>
                                                              </div>
                                                              <div className='tp-product-category'>
                                                                {product.AttributeValues ? (
                                                                  <div style={styles.productDetailsVariation}>
                                                                    <div style={styles.productDetailsVariationItem}>
                                                                      <div style={styles.productDetailsVariationList}>
                                                                        {product.AttributeValues.split(',').map((color, colorIndex) => (
                                                                          <ColorSwatch
                                                                            key={colorIndex}
                                                                            color={color}
                                                                            tooltipStyle={styles.colorVariationTooltip}
                                                                            onClick={() => handleColorSelection(product.Id, colorIndex, product.AttributeImages)}
                                                                          />
                                                                        ))}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  <>LOADING</>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      ))
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </ul>
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                        </>
                        )}
                      </nav>



                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6">
                    <div className="main-menu menu-style-1">
                      <nav className="tp-main-menu-content">
                        <ul>

                          <li><Link to="/shop">Shop</Link></li>

                          <li><Link to="/aboutus">About Us</Link></li>
                          <li><Link to="/storeLocator">Our Stores</Link></li>
                          <li><Link to="/blogs">Blogs</Link></li>
                          <li><Link to="/shop?category=19">Sets</Link></li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-3">
                    <div className="tp-header-contact d-flex align-items-center justify-content-end">
                      <div className="tp-header-contact-icon">
                        <span>
                          <svg width={21} height={20} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M1.96977 3.24859C2.26945 2.75144 3.92158 0.946726 5.09889 1.00121C5.45111 1.03137 5.76246 1.24346 6.01544 1.49057H6.01641C6.59631 2.05874 8.26011 4.203 8.35352 4.65442C8.58411 5.76158 7.26378 6.39979 7.66756 7.5157C8.69698 10.0345 10.4707 11.8081 12.9908 12.8365C14.1058 13.2412 14.7441 11.9219 15.8513 12.1515C16.3028 12.2459 18.4482 13.9086 19.0155 14.4894V14.4894C19.2616 14.7414 19.4757 15.0537 19.5049 15.4059C19.5487 16.6463 17.6319 18.3207 17.2583 18.5347C16.3767 19.1661 15.2267 19.1544 13.8246 18.5026C9.91224 16.8749 3.65985 10.7408 2.00188 6.68096C1.3675 5.2868 1.32469 4.12906 1.96977 3.24859Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.936 1.23685C16.4432 1.62622 19.2124 4.39253 19.6065 7.89874" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.936 4.59337C14.6129 4.92021 15.9231 6.23042 16.2499 7.90726" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                      </div>
                      <div className="tp-header-contact-content">
                        <h5>Hotline:</h5>
                        <p><a href="tel:402-763-282-46" target='_blank'>+92-55-111-936-936</a></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* header area end */}
      <div id="header-sticky-2" className="tp-header-sticky-area">
        <div className="container">
          <div className="tp-mega-menu-wrapper p-relative">
            <div className="row align-items-center">
              <div className="col-xl-3 col-lg-3 col-md-3 col-6">
                <div className="logo">
                  <Link to="/">
                    <img src="/assets/img/logo/logo122.png" alt="logo" style={{ width: '150px' }} />
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 d-none d-md-block">
                <div className="tp-header-sticky-menu main-menu menu-style-1">
                  <nav id="mobile-menu">
                    <ul>
                      <li><Link to="/shop">Shop</Link></li>
                      <li><Link to="/aboutus">About Us</Link></li>
                      <li><Link to="/storeLocator">Our Stores</Link></li>
                      <li><Link to="/blogs">Blogs</Link></li>
                      <li><Link to="/shop?category=19">Sets</Link></li>

                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-6">
                <div className="tp-header-action d-flex align-items-center justify-content-end ml-50">
                  <div className="tp-header-action-item d-none d-lg-block">
                    <Link to="/wishlist" className="tp-header-action-btn" aria-label="View Wishlist">
                      <svg width={22} height={20} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M11.239 18.8538C13.4096 17.5179 15.4289 15.9456 17.2607 14.1652C18.5486 12.8829 19.529 11.3198 20.1269 9.59539C21.2029 6.25031 19.9461 2.42083 16.4289 1.28752C14.5804 0.692435 12.5616 1.03255 11.0039 2.20148C9.44567 1.03398 7.42754 0.693978 5.57894 1.28752C2.06175 2.42083 0.795919 6.25031 1.87187 9.59539C2.46978 11.3198 3.45021 12.8829 4.73806 14.1652C6.56988 15.9456 8.58917 17.5179 10.7598 18.8538L10.9949 19L11.239 18.8538Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M7.26062 5.05302C6.19531 5.39332 5.43839 6.34973 5.3438 7.47501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span style={visuallyHiddenStyle}>Wishlist</span>
                      {wishlistItems.length > 0 && (
                        <span className="tp-header-action-badge">{wishlistItems.length}</span>
                      )}
                    </Link>
                  </div>
                  <div className="tp-header-action-item">
                    <button type="button" className="tp-header-action-btn cartmini-open-btn" aria-label="Open shopping cart">
                      <svg width={21} height={22} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.48626 20.5H14.8341C17.9004 20.5 20.2528 19.3924 19.5847 14.9348L18.8066 8.89359C18.3947 6.66934 16.976 5.81808 15.7311 5.81808H5.55262C4.28946 5.81808 2.95308 6.73341 2.4771 8.89359L1.69907 14.9348C1.13157 18.889 3.4199 20.5 6.48626 20.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M6.34902 5.5984C6.34902 3.21232 8.28331 1.27803 10.6694 1.27803V1.27803C11.8184 1.27316 12.922 1.72619 13.7362 2.53695C14.5504 3.3477 15.0081 4.44939 15.0081 5.5984V5.5984" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M7.70365 10.1018H7.74942" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.5343 10.1018H13.5801" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="tp-header-action-badge">{cartItems.length}</span>
                    </button>
                  </div>
                  <div className="tp-header-action-item d-lg-none">
                    <button type="button" className="tp-header-action-btn tp-offcanvas-open-btn" aria-label="Open menu">
                      <svg xmlns="http://www.w3.org/2000/svg" width={30} height={16} viewBox="0 0 30 16">
                        <rect x={10} width={20} height={2} fill="currentColor" />
                        <rect x={5} y={7} width={25} height={2} fill="currentColor" />
                        <rect x={10} y={14} width={20} height={2} fill="currentColor" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @media (max-width: 991px) {
          .back-to-top-wrapper {
            bottom: 90px !important;
          }
        }
      `}</style>
    </>
  )
}
